/* SST product page: spec accordions (Specifications, Wood Screw Sizes, ...).
   Replaces Bootstrap's collapse on .sst-pdp a.collape-header: it reacts on the
   click itself and animates with a grid-row transition instead of measuring heights. */
(function () {
  'use strict';

  function prep(link) {
    if (link.dataset.sstAcc) return;
    var id = (link.getAttribute('href') || '').replace(/^#/, '');
    var body = id && document.getElementById(id);
    if (!body) return;
    link.dataset.sstAcc = '1';
    link.removeAttribute('data-toggle');
    link.setAttribute('role', 'button');
    link.setAttribute('aria-controls', id);
    var open = body.classList.contains('show');
    link.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.classList.remove('collapse', 'collapsing', 'show', 'p-3');
    body.classList.add('sst-acc');
    body.classList.toggle('is-open', open);
    var inner = document.createElement('div');
    inner.className = 'sst-acc__inner';
    var pad = document.createElement('div');
    pad.className = 'sst-acc__pad';
    while (body.firstChild) pad.appendChild(body.firstChild);
    inner.appendChild(pad);
    body.appendChild(inner);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.sst-pdp a.collape-header'), prep);
  }

  // Capture phase, so Bootstrap's delegated handler never sees the click.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.sst-pdp a.collape-header');
    if (!link) return;
    prep(link);
    var body = document.getElementById(link.getAttribute('aria-controls') || '');
    if (!body) return;
    e.preventDefault();
    e.stopPropagation();
    var open = link.getAttribute('aria-expanded') !== 'true';
    link.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.classList.toggle('is-open', open);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
